const BASE = 'app/settings/';

const SET_NUMBER_OF_PLAYERS = BASE + 'SET_NUMBER_OF_PLAYERS';
const SET_DIFFICULTY = BASE + 'SET_DIFFICULTY';
const SET_SHOW_INCLUDED_SKILLS = BASE + 'SET_SHOW_INCLUDED_SKILLS';
const SET_SHOW_ACTIVE_SKILLS = BASE + 'SET_SHOW_ACTIVE_SKILLS';
const SET_SHOW_PASSIVE_SKILLS = BASE + 'SET_SHOW_PASSIVE_SKILLS';
const SET_SHOW_PHASE_MODAL = BASE + 'SET_SHOT_PHASE_MODAL';
const SET_SHOW_RULE_ROLL_MODAL = BASE + 'SET_SHOW_RULE_ROLL_MODAL';
const RESTART_GAME = BASE + 'RESTART_GAME';
const RESTORE_SETTINGS = BASE + 'RESTORE_SETTINGS';
const SHOW_SESSION_TOKEN = BASE + 'SHOW_SESSION_TOKEN';
const SHOW_SESSION_MENU = BASE + 'SHOW_SESSION_MENU';

export default {
  SET_NUMBER_OF_PLAYERS,
  SET_DIFFICULTY,
  SET_SHOW_INCLUDED_SKILLS,
  SET_SHOW_ACTIVE_SKILLS,
  SET_SHOW_PASSIVE_SKILLS,
  SET_SHOW_PHASE_MODAL,
  SET_SHOW_RULE_ROLL_MODAL,
  RESTART_GAME,
  RESTORE_SETTINGS,
  SHOW_SESSION_TOKEN,
  SHOW_SESSION_MENU,
};
